/**
 * Component permission for Delete Accessorial.
 *
 * V1 gated this on its own ACL — `getACL("access_orders","","delete_accessorial")` at
 * lib_editrecord.pl:18992 — and rendered the link only at write level. It is the one
 * destructive action on the accessorial modal: the row leaves the list for good (there
 * is no undelete and no show-deleted toggle), its line items are deliberately left
 * behind, and its accessorialnum is never reused.
 *
 * It arrived in 360 as a bare "Deleted" Y/N dropdown on the modal with no gate at all,
 * so anyone who could edit an accessorial could quietly remove one. This restores the
 * separation: editing an accessorial and deleting one are different jobs with different
 * audiences, the same split as `invoice-approval` (migration 498) and
 * `invoice-bill-from` (505).
 *
 * Consumed through `<PermissionsContainer>` rather than a `useResolvedAccessLevel`
 * hook, and that choice matters: only the container mounts PermissionConfigurable,
 * which self-registers the component into `pageComponents` while Permissions Mode is
 * on. A hook resolves the level correctly but registers nothing, leaving the component
 * invisible to the in-app permissions editor and configurable only by writing to
 * `component_permissions` by hand.
 *
 * Ships **defaultHidden**: with no grant there is no button, matching V1, where the
 * link simply is not rendered without the ACL. That is the safe default for a
 * destructive action — a missing grant costs someone a button, while a permissive one
 * costs a billing record. Seeded by migration 515 to whoever already holds
 * `pro-invoicing-write` at Edit, so nobody gains or loses the ability.
 *
 * The gate is necessary but not sufficient. The button is also hidden once the
 * accessorial has been invoiced, and the backend refuses that case independently —
 * with no Admin Override arm, unlike every other lock on this modal, because V1 never
 * allows deleting a billed accessorial at any privilege level.
 */
export const ACCESSORIAL_DELETE_COMPONENT_ID = 'accessorial-delete';
export const ACCESSORIAL_DELETE_COMPONENT_NAME = 'Pro Invoicing — Delete Accessorial';
